import styles from '../../styles/modules/home/HomeFeatures.module.scss';

const FEATURES = [
  'Юридическая проверка недвижимости и участников сделки',
  'Безопасный расчет между продавцом и покупателем',
  'Выдача гарантийного сертификата покупателю',
  'Ни одной расторгнутой сделки с 1994 года'
];

const HomeFeatures = () => {
  return (
    <section className={['block', styles.block].join(' ')}>
      <div className="fixed">
        <h3 className={styles.title}>Гарантия безопасности сделки</h3>
        <div className={styles.features}>
          {FEATURES.map((text, i) => (
            <div key={i} className={styles.featuresItem}>
              <div className={styles.featuresItemBar}>
                <div className={styles.featuresItemNumber}>{i + 1}</div>
                <div className={styles.featuresItemImage}>
                  <img src="/images/pattern.svg" alt="" />
                </div>
              </div>
              <div className={styles.featuresItemText}>{text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeFeatures;
